export const RuleSetType = Object.freeze({
    AwardingRule: 1,
    ValidationRule: 2,
    BreakRule: 3,
});
